import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
      <h1 className="font-serif text-3xl text-[#0B1F3A]">Page not found</h1>
      <p className="text-sm text-[#475569] mt-3">The page you're looking for doesn't exist or has moved.</p>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <Link to="/" className="bg-[#1D4ED8] text-white rounded-md px-5 py-2.5 text-sm font-bold hover:bg-[#1638A8]">Go home</Link>
        <Link to="/approvals" className="border border-[#0B1F3A]/25 text-[#0B1F3A] rounded-md px-5 py-2.5 text-sm font-medium hover:bg-white">Browse approvals</Link>
        <Link to="/wizard" className="border border-[#0B1F3A]/25 text-[#0B1F3A] rounded-md px-5 py-2.5 text-sm font-medium hover:bg-white">Map my approvals</Link>
      </div>
    </div>
  );
}
